import { useEffect } from 'react';
import howlerIntegration from 'utils/howlerIntegration';
import SOUND_CONSTANTS from 'utils/soundConstants';
import hoverSound from 'sounds/62976__radian__chime-0001.mp3';
import transitionSound from 'sounds/slide-network.mp3';

const SOUND_DATA = {
  [SOUND_CONSTANTS.TRANSITION_PAGE_OUT_SOUND]: {
    src: [transitionSound],
    volume: 0.5
  },
  [SOUND_CONSTANTS.TRANSITION_PAGE_IN_SOUND]: {
    src: [transitionSound],
    volume: 0.5
  },
  [SOUND_CONSTANTS.HOVER_BUTTON_SOUND]: {
    src: [hoverSound],
    volume: 0.04
  }
};

function DesktopWebSounds() {
  useEffect(() => howlerIntegration.addSounds(SOUND_DATA), []);
  return null;
}

export default DesktopWebSounds;
